import { Controller } from "@hotwired/stimulus"

// Modal sobre <dialog> nativo. Reemplaza los modales de Materialize.
// Si se declara `open-on-connect`, se abre apenas llega por turbo_stream.
export default class extends Controller {
  static values = { openOnConnect: { type: Boolean, default: false } }

  connect() {
    // Turbo guarda una copia de la página al navegar; si el modal queda abierto,
    // reaparece al volver atrás. Se cierra antes de que la copia se tome.
    this.closeBeforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this.closeBeforeCache)

    if (this.openOnConnectValue) this.open()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.closeBeforeCache)
    this.#unlockScroll()
  }

  open(event) {
    event?.preventDefault()
    if (!this.element.open) this.element.showModal()
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    event?.preventDefault()
    if (this.element.open) this.element.close()
    this.#unlockScroll()
  }

  // Cierra al hacer clic fuera del contenido del modal.
  closeOnBackdrop(event) {
    if (event.target === this.element) this.close()
  }

  #unlockScroll() {
    document.body.classList.remove("overflow-hidden")
  }
}
